import React, { useEffect, useState } from "react"

import GraphingButtonToolbar from "../widgets/GraphingButtonToolbar"

export default function KeyBody({
  intl, // null in LanzaLake, used in LTPM react-intl
  graphKey,
  index,
  plotEntry,
  graphs = [],
  updateGraphs,
  observationTypes,
  crossPlotProps,
  overlayRuns,
  availableRuns = [],
  siteReactors = [],
  download = false,
  toggleAvailable = false,
  availableOnly = false,
  keyShowing = true,
  liveView = false,
  allowCollapse = true,
  allowTagSelection = true,
  allowGraphEdit = true,
  timeExtractor,
  baseTime,
  axesAndRanges,
}) {
  const plotFactory = plotEntry.plotFactory

  const keyDetailsVisibility = {
    hide: "fa fa-solid fa-caret-down fa-lg",
    show: "fa fa-solid fa-caret-up fa-lg",
  }

  const [showKey, setShowKey] = useState(true)

  useEffect(() => {
    setShowKey(keyShowing)
  }, [])

  return (
    <div style={!liveView && !download ? { backgroundColor: "var(--lanzalake-white)" } : { width: "100%" }}>
      {/* Button toolbar and show/hide caret to toggle key visibility */}
      {!download && !liveView && (
        <div style={{ display: "flex" }}>
          {allowCollapse && (
            <span
              className={showKey ? keyDetailsVisibility.show : keyDetailsVisibility.hide}
              style={{ paddingLeft: "5px" }}
              onClick={() => setShowKey(!showKey)}
            />
          )}
          <div style={{ marginLeft: "auto" }}>
            {graphKey && (
              <GraphingButtonToolbar
                graphKey={graphKey}
                plotEntry={plotEntry}
                intl={intl}
                index={index}
                crossPlotProps={crossPlotProps}
                overlayRuns={overlayRuns}
                availableRuns={availableRuns}
                toggleAvailable={toggleAvailable}
                timeExtractor={timeExtractor}
                baseTime={baseTime}
                axesAndRanges={axesAndRanges}
                allowGraphEdit={allowGraphEdit}
                small
              />
            )}
          </div>
        </div>
      )}

      {(showKey || download) && graphKey && (
        <div style={{ padding: "5px" }}>
          {plotFactory && (
            <plotFactory.Key
              observationTypes={observationTypes}
              plotConfigUpdater={plotEntry.plotConfigUpdater}
              graphs={graphs}
              graphKey={graphKey}
              graphIndex={index}
              updateGraphs={updateGraphs}
              download={download}
              intl={intl}
              liveView={liveView}
              allowTagSelection={allowTagSelection}
              siteReactors={siteReactors}
              availableOnly={availableOnly}
              {...crossPlotProps}
            />
          )}
        </div>
      )}
    </div>
  )
}
